import React from "react";

const NetworkServiceForm = props => {
  return (
    <div className="details_form info_text">
      This service element has no details of its own. Service outages and
      disruptions are recorded as damages to this element in surveys.
    </div>
  );
};

export default NetworkServiceForm;
